import { Auth0ProviderOptions } from "@auth0/auth0-react";
import { config } from "./config";

export const auth0Config: Auth0ProviderOptions = {
  domain: config.auth0.domain,
  clientId: config.auth0.clientId,
  cacheLocation: "localstorage",
  useRefreshTokens: true,
  useRefreshTokensFallback: true,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: config.auth0.audience,
    ...(config.appEnv !== "production"
      ? { cohesive_api_base_url: config.hosts.api }
      : {}),
  },
};
